import { h } from "preact";

import classname from "../../../../foundation/utils/classname";
import PlaceholderBlock from "../../PlaceholderBlock";
import { getComponentCardImageDimensions, getComponentCardWidth, getComponentImageHeight } from "../utils";

import styles from "./ComponentCardPlaceholder.module.css";

interface Props {
    class?: string;
    imageWidth: number;
    imageHeight: number;
    smallSize?: boolean;
}

function BarrelCardPlaceholder({
    class: cssClass,
    imageWidth,
    imageHeight,
    smallSize = false
}: Props) {
    const componentImageHeight = getComponentImageHeight({ smallSize });
    const componentCardWidth = getComponentCardWidth(imageWidth, imageHeight, { smallSize });

    const componentCardStyle = {
        width: `${componentCardWidth}px`
    };

    const imageContainerStyle = {
        height: `${componentImageHeight}px`
    };

    const imageWrapperStyle = getComponentCardImageDimensions(imageWidth, imageHeight, { smallSize });

    return (
        <div
            class={classname(styles.componentCardPlaceholder, cssClass, {
                [styles.smallSize]: smallSize
            })}
            style={componentCardStyle}>
            <div class={styles.imageContainer} style={imageContainerStyle}>
                <div class={styles.imageWrapper} style={imageWrapperStyle}>
                    <PlaceholderBlock class={styles.image}/>
                </div>
            </div>
            <div class={styles.nameContainer}>
                <PlaceholderBlock class={styles.icon}/>
                <PlaceholderBlock class={styles.name}/>
            </div>
        </div>
    );
}

export default BarrelCardPlaceholder;
